export const seoPages = {
  "creation-site-vitrine": {
    slug: "creation-site-vitrine",
    title: "Création de site vitrine professionnel",
    metaTitle: "Création de site vitrine professionnel en France | Fold Web Agency",
    metaDescription:
      "Création de sites vitrines modernes, rapides et responsives pour indépendants, TPE, PME, cabinets et prestataires de services partout en France.",
    eyebrow: "Site vitrine",
    heroTitle: "Création de site vitrine professionnel pour gagner en crédibilité",
    intro:
      "Fold Web Agency crée des sites vitrines professionnels pour présenter votre activité, rassurer vos prospects et transformer les visites en prises de contact. Chaque page est pensée pour être claire, rapide, lisible sur mobile et compréhensible par Google.",
    bullets: [
      "Arborescence claire pour présenter votre entreprise, vos services et vos preuves de confiance",
      "Design responsive adapté au mobile, à la tablette et à l'ordinateur",
      "Formulaire de contact, boutons d'action et parcours de conversion visibles",
      "Balises title, meta description, titres Hn, maillage interne et base SEO propre",
    ],
    sections: [
      {
        title: "Pour quels professionnels ?",
        body:
          "Un site vitrine est idéal pour une entreprise de service, un indépendant, un cabinet, un commerce, une association ou une PME qui veut présenter son activité de manière professionnelle. Nous construisons des pages utiles pour les visiteurs : services, réalisations, avis, présentation, contact et informations essentielles.",
      },
      {
        title: "Une structure orientée conversion",
        body:
          "Nous construisons chaque page autour d'un objectif simple : comprendre vite, rassurer, puis contacter. L'arborescence, les textes, les visuels et les boutons sont pensés pour accompagner un visiteur qui découvre votre entreprise et l'aider à passer à l'action sans friction.",
      },
      {
        title: "Une base SEO dès la mise en ligne",
        body:
          "La création du site intègre les fondamentaux du référencement naturel : URL propres, balises cohérentes, contenus structurés, sitemap, responsive design et temps de chargement maîtrisé. L'objectif est de donner à Google des signaux clairs dès le lancement.",
      },
    ],
    faq: [
      {
        question: "Combien de pages faut-il pour un site vitrine ?",
        answer:
          "La plupart des projets commencent avec 4 à 8 pages : accueil, services, réalisations, à propos, contact et pages légales.",
      },
      {
        question: "Le site sera-t-il visible sur mobile ?",
        answer:
          "Oui, le responsive est intégré dès le départ pour offrir une expérience confortable sur mobile, tablette et ordinateur.",
      },
      {
        question: "Le site vitrine peut-il évoluer plus tard ?",
        answer:
          "Oui. Le site peut commencer simplement puis évoluer avec de nouvelles pages, des contenus SEO, un espace client, des formulaires avancés ou des intégrations selon vos besoins.",
      },
    ],
  },
  "creation-site-wordpress": {
    slug: "creation-site-wordpress",
    title: "Création de site WordPress",
    metaTitle: "Création de site WordPress professionnel | Fold Web Agency",
    metaDescription:
      "Création de sites WordPress professionnels, performants, sécurisés et faciles à administrer pour entreprises, indépendants et PME en France.",
    eyebrow: "WordPress",
    heroTitle: "Création de site WordPress propre, évolutif et simple à gérer",
    intro:
      "Nous créons des sites WordPress adaptés aux besoins des professionnels : présentation de services, acquisition de contacts, gestion simple des contenus et base technique durable. L'objectif est d'avoir un site administrable sans sacrifier la performance ni la clarté.",
    bullets: [
      "Installation et configuration WordPress",
      "Thème adapté à votre identité visuelle et à vos objectifs commerciaux",
      "Pages administrables, contenus structurés et blocs faciles à modifier",
      "Optimisation performance, sécurité, sauvegardes et SEO de base",
    ],
    sections: [
      {
        title: "WordPress sans lourdeur inutile",
        body:
          "WordPress est puissant lorsqu'il est bien cadré. Nous évitons les empilements de plugins inutiles et nous gardons une structure maintenable, pour un site plus stable et plus facile à faire évoluer.",
      },
      {
        title: "Autonomie après livraison",
        body:
          "L'objectif est que vous puissiez modifier les contenus essentiels sans dépendance permanente. Nous pouvons aussi assurer la maintenance si vous préférez nous confier la partie technique.",
      },
      {
        title: "Un WordPress pensé pour durer",
        body:
          "Nous préparons le site avec une logique de croissance : pages services, blog, formulaires, suivi statistique, redirections et optimisations SEO peuvent être ajoutés progressivement sans repartir de zéro.",
      },
    ],
    faq: [
      {
        question: "Puis-je modifier mon site WordPress moi-même ?",
        answer:
          "Oui. Les contenus principaux peuvent être rendus administrables pour que vous puissiez mettre à jour textes, images et pages.",
      },
      {
        question: "WordPress est-il adapté au SEO ?",
        answer:
          "Oui, à condition d'avoir une structure propre, des pages rapides, des titres cohérents et des contenus utiles.",
      },
      {
        question: "Pouvez-vous optimiser un WordPress déjà en ligne ?",
        answer:
          "Oui. Nous pouvons auditer un site WordPress existant, corriger les points bloquants et améliorer la structure, les performances, la sécurité et les contenus.",
      },
    ],
  },
  "maintenance-wordpress": {
    slug: "maintenance-wordpress",
    title: "Maintenance WordPress",
    metaTitle: "Maintenance WordPress et sécurité | Fold Web Agency",
    metaDescription:
      "Maintenance WordPress pour garder votre site à jour, sécurisé, sauvegardé, fonctionnel et performant dans la durée.",
    eyebrow: "Maintenance",
    heroTitle: "Maintenance WordPress pour garder un site fiable, rapide et sécurisé",
    intro:
      "La maintenance WordPress permet de limiter les bugs, les failles de sécurité, les ralentissements et les interruptions. Nous assurons le suivi technique pour que votre site reste stable et disponible pour vos visiteurs.",
    bullets: [
      "Mises à jour WordPress, thèmes et extensions",
      "Sauvegardes, contrôles après mise à jour et vérification du bon fonctionnement",
      "Surveillance des formulaires et éléments critiques",
      "Interventions correctives, conseils techniques et suivi des alertes",
    ],
    sections: [
      {
        title: "Pourquoi maintenir un site ?",
        body:
          "Un site WordPress évolue avec son environnement : versions PHP, plugins, navigateurs, sécurité. Sans suivi, de petites alertes peuvent devenir des blocages visibles pour vos clients.",
      },
      {
        title: "Un suivi adapté à votre activité",
        body:
          "Nous pouvons intervenir ponctuellement ou mettre en place un suivi régulier. L'objectif est de protéger le site sans complexifier votre quotidien.",
      },
      {
        title: "Moins de risques pour votre visibilité",
        body:
          "Un site indisponible, piraté ou lent peut nuire à l'expérience utilisateur et au référencement. La maintenance aide à conserver une base saine pour vos prospects, vos formulaires et votre visibilité Google.",
      },
    ],
    faq: [
      {
        question: "La maintenance est-elle obligatoire ?",
        answer:
          "Elle n'est pas obligatoire, mais elle est fortement recommandée pour éviter les failles, les incompatibilités et les pertes de données.",
      },
      {
        question: "Pouvez-vous reprendre un site existant ?",
        answer:
          "Oui, après un audit rapide de l'installation, des extensions et de l'hébergement.",
      },
      {
        question: "Que se passe-t-il en cas de bug ?",
        answer:
          "Nous analysons l'origine du problème, sécurisons les éléments critiques et proposons une correction adaptée selon l'urgence et le niveau de maintenance prévu.",
      },
    ],
  },
  "referencement-seo": {
    slug: "referencement-seo",
    title: "Référencement SEO",
    metaTitle: "Référencement SEO pour site professionnel | Fold Web Agency",
    metaDescription:
      "Optimisation SEO pour améliorer la compréhension de votre site par Google, renforcer votre visibilité et attirer un trafic qualifié en France.",
    eyebrow: "SEO",
    heroTitle: "Référencement SEO pour être mieux compris par Google",
    intro:
      "Nous travaillons le SEO comme un levier de visibilité durable : technique propre, contenus utiles, structure lisible et signaux de confiance. L'objectif est d'aider vos pages à répondre clairement aux recherches de vos prospects.",
    bullets: [
      "Audit technique et corrections prioritaires",
      "Optimisation des titres, metas et contenus",
      "Structure de pages par intention de recherche",
      "Maillage interne et recommandations de notoriété",
    ],
    sections: [
      {
        title: "Un SEO centré sur l'intention",
        body:
          "Une page performe mieux quand elle répond à une question précise. Nous construisons les contenus autour des recherches réelles de vos prospects, sans bourrage de mots-clés.",
      },
      {
        title: "Technique et contenu ensemble",
        body:
          "Le SEO ne se résume pas aux balises. Il faut aussi des pages rapides, accessibles, bien reliées entre elles et suffisamment utiles pour mériter des liens et des contacts.",
      },
      {
        title: "Une progression nationale, sans ciblage local forcé",
        body:
          "Nous pouvons travailler une visibilité sur toute la France avec des pages de services claires, des contenus de fond, des cas clients et un maillage interne cohérent. L'objectif n'est pas de multiplier des pages géographiques faibles, mais de construire une autorité utile.",
      },
    ],
    faq: [
      {
        question: "Combien de temps faut-il pour voir des résultats SEO ?",
        answer:
          "Les premiers signaux peuvent apparaître en quelques semaines, mais une progression durable se mesure plutôt sur plusieurs mois.",
      },
      {
        question: "Le SEO remplace-t-il la publicité ?",
        answer:
          "Non. Le SEO construit une visibilité durable, tandis que la publicité peut générer du trafic plus rapidement. Les deux peuvent se compléter.",
      },
      {
        question: "Faut-il créer beaucoup de pages pour progresser ?",
        answer:
          "Pas forcément. Il vaut mieux créer moins de pages mais plus utiles, avec une intention claire, un contenu complet, des liens internes et des preuves de confiance.",
      },
    ],
  },
  "site-vitrine-avocat": {
    slug: "site-vitrine-avocat",
    title: "Site vitrine pour avocat",
    metaTitle: "Création de site vitrine pour avocat | Fold Web Agency",
    metaDescription:
      "Création de site vitrine pour avocat, cabinet juridique ou activité de conseil : image professionnelle, informations claires et prise de contact facilitée.",
    eyebrow: "Professions juridiques",
    heroTitle: "Un site vitrine sobre et crédible pour votre cabinet d'avocat",
    intro:
      "Un cabinet d'avocat doit inspirer confiance dès les premières secondes. Fold Web Agency conçoit des sites vitrines clairs, élégants et rassurants pour présenter vos domaines d'intervention, votre parcours et les moyens de vous contacter.",
    bullets: [
      "Présentation claire du cabinet, des domaines d'intervention et du parcours",
      "Design sobre, professionnel et cohérent avec les codes juridiques",
      "Pages structurées pour les recherches liées aux services du cabinet",
      "Formulaire de contact, téléphone et appels à l'action visibles",
    ],
    sections: [
      {
        title: "Un site pensé pour rassurer",
        body:
          "Les visiteurs d'un site d'avocat cherchent souvent une réponse fiable dans un moment important. Le site doit donc être lisible, sérieux et direct : qui vous êtes, ce que vous traitez, comment vous contacter et pourquoi vous faire confiance.",
      },
      {
        title: "Des contenus adaptés à vos domaines",
        body:
          "Droit des affaires, droit immobilier, droit de la famille, droit social ou accompagnement des entreprises : chaque domaine peut être présenté avec une page claire, sans jargon inutile, pour aider les prospects à comprendre votre champ d'action.",
      },
      {
        title: "Une base technique propre",
        body:
          "Nous travaillons la structure, les balises, la performance mobile, le formulaire et le maillage interne pour donner au site une base saine. L'objectif est d'avoir une vitrine professionnelle qui peut évoluer avec votre cabinet.",
      },
    ],
    faq: [
      {
        question: "Un site d'avocat peut-il être sobre et efficace ?",
        answer:
          "Oui. Pour une profession juridique, la sobriété est souvent un atout. L'important est de rendre l'information accessible, rassurante et facile à parcourir.",
      },
      {
        question: "Peut-on créer des pages par domaine d'intervention ?",
        answer:
          "Oui. C'est même recommandé lorsque le cabinet intervient sur plusieurs sujets. Chaque page peut répondre à une intention de recherche précise.",
      },
      {
        question: "Le site peut-il reprendre l'identité du cabinet ?",
        answer:
          "Oui. Le design peut s'adapter à votre logo, vos couleurs, vos photos et votre positionnement, tout en conservant une expérience claire et professionnelle.",
      },
    ],
  },
  "site-vitrine-consultant": {
    slug: "site-vitrine-consultant",
    title: "Site vitrine pour consultant",
    metaTitle: "Création de site vitrine pour consultant | Fold Web Agency",
    metaDescription:
      "Création de site vitrine pour consultant indépendant, formateur ou expert B2B : positionnement clair, offres lisibles et génération de contacts.",
    eyebrow: "Consultants",
    heroTitle: "Un site vitrine pour clarifier votre expertise de consultant",
    intro:
      "Un consultant doit expliquer rapidement sa valeur, son positionnement et les résultats qu'il peut apporter. Nous créons des sites vitrines qui structurent votre expertise, vos offres et vos preuves pour transformer les visites en demandes qualifiées.",
    bullets: [
      "Positionnement, offres et bénéfices présentés de manière claire",
      "Pages adaptées aux consultants, formateurs, coachs et experts B2B",
      "Mise en avant des preuves : cas clients, témoignages, méthode, résultats",
      "Structure SEO pour capter des recherches liées à votre expertise",
    ],
    sections: [
      {
        title: "Rendre votre offre plus lisible",
        body:
          "Beaucoup de consultants ont une expertise forte mais difficile à expliquer en quelques secondes. Le site doit clarifier le problème traité, les publics accompagnés, les bénéfices attendus et les modalités de prise de contact.",
      },
      {
        title: "Créer un actif commercial durable",
        body:
          "Un site de consultant peut devenir un support de prospection, un point d'appui après un rendez-vous et une preuve de sérieux. Il doit donc être plus qu'une carte de visite : il doit aider le prospect à se projeter.",
      },
      {
        title: "Préparer le développement SEO",
        body:
          "Les pages services, les articles de fond et les cas clients peuvent construire progressivement votre visibilité. Nous préparons une structure capable d'accueillir ces contenus sans repartir de zéro.",
      },
    ],
    faq: [
      {
        question: "Un consultant a-t-il vraiment besoin d'un site vitrine ?",
        answer:
          "Oui, surtout lorsqu'il vend une expertise. Le site aide à crédibiliser le positionnement, expliquer l'offre et rassurer les prospects avant la prise de contact.",
      },
      {
        question: "Peut-on intégrer des cas clients ?",
        answer:
          "Oui. Les cas clients sont très utiles pour prouver votre méthode, montrer votre expérience et aider les visiteurs à comprendre vos résultats.",
      },
      {
        question: "Le site peut-il servir au référencement national ?",
        answer:
          "Oui. En travaillant les pages services et les contenus autour de vos expertises, le site peut viser des recherches sur toute la France.",
      },
    ],
  },
  "site-vitrine-sport": {
    slug: "site-vitrine-sport",
    title: "Site vitrine pour coach sportif et activité sport",
    metaTitle: "Création de site vitrine sport et coach sportif | Fold Web Agency",
    metaDescription:
      "Création de site vitrine pour coach sportif, studio, cours collectifs, discipline bien-être ou activité sportive en France.",
    eyebrow: "Sport et bien-être",
    heroTitle: "Un site vitrine dynamique pour votre activité sportive",
    intro:
      "Un coach sportif, un studio ou une activité bien-être doit donner envie, rassurer et faciliter la réservation ou la prise de contact. Fold Web Agency crée des sites vitrines clairs, modernes et orientés conversion pour présenter vos cours, votre méthode et vos offres.",
    bullets: [
      "Présentation des cours, abonnements, séances privées ou offres collectives",
      "Design visuel adapté au sport, au mouvement et au bien-être",
      "Mise en avant des photos, horaires, tarifs, témoignages et résultats",
      "Parcours de contact clair pour réserver, demander un essai ou poser une question",
    ],
    sections: [
      {
        title: "Pour quelles activités sportives ?",
        body:
          "Cette page s'adresse aux coachs sportifs, studios de yoga, Pilates, barre au sol, danse, fitness, préparation physique, activités bien-être et structures sportives indépendantes. Le site doit aider le visiteur à comprendre l'offre et à se projeter rapidement.",
      },
      {
        title: "Transformer l'intérêt en réservation",
        body:
          "Un site sport efficace ne se contente pas d'être beau. Il doit rendre les informations pratiques accessibles : types de cours, niveaux, planning, lieu, tarifs, contact et prochaines étapes. Chaque élément doit réduire l'hésitation avant la prise de contact.",
      },
      {
        title: "Une vitrine utile pour la visibilité",
        body:
          "Les contenus peuvent être structurés autour des disciplines, des publics et des bénéfices : remise en forme, mobilité, posture, performance ou bien-être. Cela permet de construire une visibilité progressive sans dépendre uniquement des réseaux sociaux.",
      },
    ],
    faq: [
      {
        question: "Un coach sportif peut-il recevoir des demandes depuis son site ?",
        answer:
          "Oui. Le site peut intégrer des boutons de contact, un formulaire, des liens vers une plateforme de réservation ou des appels à l'action pour une séance d'essai.",
      },
      {
        question: "Peut-on mettre en avant les horaires et tarifs ?",
        answer:
          "Oui. Les horaires, tarifs, formules, abonnements et conditions peuvent être présentés clairement pour limiter les questions répétitives.",
      },
      {
        question: "Le site peut-il compléter Instagram ?",
        answer:
          "Oui. Les réseaux sociaux créent de la visibilité, mais le site sert de base professionnelle stable, mieux structurée et plus facile à référencer.",
      },
    ],
  },
  "site-vitrine-service-a-la-personne": {
    slug: "site-vitrine-service-a-la-personne",
    title: "Site vitrine pour service à la personne et jardinage",
    metaTitle:
      "Création de site vitrine service à la personne et jardinage | Fold Web Agency",
    metaDescription:
      "Création de site vitrine pour jardinage, entretien d'espaces verts, aide à domicile, services à la personne et prestations de proximité.",
    eyebrow: "Services à la personne",
    heroTitle: "Un site vitrine rassurant pour vos services à domicile",
    intro:
      "Les métiers de service à la personne reposent sur la confiance, la clarté et la proximité. Nous créons des sites vitrines professionnels pour présenter vos prestations, rassurer les familles ou particuliers et générer des demandes qualifiées.",
    bullets: [
      "Présentation claire des prestations : jardinage, entretien, aide ou accompagnement",
      "Mise en avant des zones d'intervention sans enfermer le site dans une seule ville",
      "Informations pratiques : devis, disponibilité, contact, engagements et garanties",
      "Structure SEO adaptée aux recherches de particuliers et de professionnels",
    ],
    sections: [
      {
        title: "Pour quels services ?",
        body:
          "Cette page peut couvrir les prestations de jardinage, entretien d'espaces verts, petits travaux, aide à domicile, accompagnement, ménage, services seniors ou assistance ponctuelle. L'objectif est de rendre l'offre immédiatement compréhensible.",
      },
      {
        title: "Créer la confiance avant le premier contact",
        body:
          "Les visiteurs veulent savoir qui intervient, ce qui est inclus, comment demander un devis et quelles garanties existent. Un site bien structuré rassure, évite les malentendus et augmente la qualité des demandes reçues.",
      },
      {
        title: "Une visibilité utile sans pages locales faibles",
        body:
          "On peut travailler une visibilité nationale ou multi-zones avec des pages de prestations solides, des exemples concrets et un maillage interne propre, plutôt que de créer beaucoup de pages géographiques répétitives.",
      },
    ],
    faq: [
      {
        question: "Un site vitrine est-il utile pour une activité de jardinage ?",
        answer:
          "Oui. Il permet de présenter les prestations, montrer des exemples, rassurer les particuliers et recevoir des demandes de devis plus qualifiées.",
      },
      {
        question: "Peut-on afficher plusieurs zones d'intervention ?",
        answer:
          "Oui. Les zones peuvent être présentées clairement sans créer de nombreuses pages presque identiques.",
      },
      {
        question: "Le site peut-il générer des demandes de devis ?",
        answer:
          "Oui. Un formulaire simple, des appels à l'action visibles et une présentation claire des services facilitent la prise de contact.",
      },
    ],
  },
  "refonte-site-internet": {
    slug: "refonte-site-internet",
    title: "Refonte de site internet",
    metaTitle: "Refonte de site internet professionnel | Fold Web Agency",
    metaDescription:
      "Refonte de site internet pour améliorer l'image, la clarté, la performance, le SEO et la conversion d'un site existant.",
    eyebrow: "Refonte web",
    heroTitle: "Refonte de site internet pour repartir sur une base plus solide",
    intro:
      "Un site vieillissant, lent ou peu clair peut freiner la confiance et les demandes de contact. Fold Web Agency accompagne la refonte de sites internet pour améliorer l'expérience, les contenus, le référencement et la capacité du site à convertir.",
    bullets: [
      "Audit de l'existant : design, contenus, performance, SEO et conversion",
      "Nouvelle structure de pages plus claire pour les visiteurs et Google",
      "Refonte graphique responsive avec parcours de contact plus efficace",
      "Préservation des URLs importantes, redirections et suivi post-mise en ligne",
    ],
    sections: [
      {
        title: "Quand envisager une refonte ?",
        body:
          "Une refonte devient pertinente lorsque le site ne reflète plus votre niveau actuel, ne génère pas assez de demandes, se charge lentement ou devient difficile à modifier. Elle permet de corriger la base plutôt que d'empiler des ajustements ponctuels.",
      },
      {
        title: "Refondre sans perdre le SEO",
        body:
          "Une refonte doit être préparée avec méthode : analyse des pages existantes, conservation des contenus utiles, redirections 301, nouvelles balises, sitemap et vérification dans Google Search Console. L'objectif est d'améliorer le site sans casser sa visibilité.",
      },
      {
        title: "Une meilleure expérience pour convertir",
        body:
          "La refonte permet de revoir les messages, les appels à l'action, les preuves de confiance et la navigation. Le site devient plus lisible pour les visiteurs et plus cohérent avec vos objectifs commerciaux.",
      },
    ],
    faq: [
      {
        question: "Une refonte peut-elle faire perdre du référencement ?",
        answer:
          "Oui si elle est mal préparée. C'est pourquoi il faut analyser les anciennes pages, conserver les contenus utiles et mettre en place les bonnes redirections.",
      },
      {
        question: "Faut-il tout refaire ou améliorer l'existant ?",
        answer:
          "Cela dépend de l'état du site. Parfois une optimisation suffit, mais lorsqu'il y a des problèmes de structure, d'image ou de performance, une refonte complète est plus saine.",
      },
      {
        question: "Pouvez-vous reprendre un site déjà en ligne ?",
        answer:
          "Oui. Nous pouvons auditer le site existant, identifier les priorités et proposer une refonte adaptée à vos objectifs.",
      },
    ],
  },
};

export const seoPageList = Object.values(seoPages);
